import type { HudBridge } from "../Game";
import type { ThemePack } from "../theme";

function el(tag: string, className: string): HTMLElement {
  const node = document.createElement(tag);
  node.className = className;
  return node;
}

// DOM 覆盖层 HUD：关卡条、提示按钮、主题切换、Toast。
// 采用「Pixi 画棋盘 + DOM 画 UI」的混合方案——emoji/文字 UI 用 DOM 最省事且可访问。
export class Hud implements HudBridge {
  private readonly levelTag = el("div", "hud-level");
  private readonly infoText = el("div", "hud-info");
  private readonly toast = el("div", "hud-toast");
  private readonly hintBtn = document.createElement("button");
  private readonly themeSelect = document.createElement("select");
  private toastTimer = 0;

  constructor(root: HTMLElement) {
    const status = el("div", "hud-status");
    this.levelTag.textContent = "⚡ LEVEL 1";
    status.append(this.levelTag, this.infoText);

    const controls = el("div", "hud-controls");
    this.hintBtn.className = "hud-hint";
    this.hintBtn.type = "button";
    this.hintBtn.textContent = "💡 提示";
    this.themeSelect.className = "hud-theme";
    this.themeSelect.setAttribute("aria-label", "切换素材主题");
    controls.append(this.hintBtn, this.themeSelect);

    // 右下角版本号标识（构建期注入，见 vite.config.ts / vite-env.d.ts）
    const version = el("div", "hud-version");
    version.textContent = `v${__APP_VERSION__}`;

    root.append(status, controls, version, this.toast);
  }

  setLevel(level: number): void {
    this.levelTag.textContent = `✨ LEVEL ${level} ✨`;
  }

  setInfo(text: string): void {
    this.infoText.textContent = text;
  }

  showToast(msg: string, kind: "error" | "info" = "error"): void {
    this.toast.textContent = msg;
    this.toast.dataset.kind = kind;
    this.toast.classList.add("show");
    window.clearTimeout(this.toastTimer);
    this.toastTimer = window.setTimeout(() => this.toast.classList.remove("show"), 2000);
  }

  onHint(cb: () => void): void {
    this.hintBtn.addEventListener("click", cb);
  }

  buildThemes(
    packs: readonly ThemePack[],
    currentId: string,
    onChange: (id: string) => void,
  ): void {
    for (const pack of packs) {
      const opt = document.createElement("option");
      opt.value = pack.id;
      opt.textContent = pack.name;
      this.themeSelect.append(opt);
    }
    this.themeSelect.value = currentId;
    this.themeSelect.addEventListener("change", () => onChange(this.themeSelect.value));
  }
}
